import { useParams, Link } from 'react-router-dom'

import Fab from '@mui/material/Fab'
import OpenInNewIcon from '@mui/icons-material/OpenInNew'

import ControlBarItem from './ControlBarItem'

type OpenInNewTabControlProps = {}

export default function OpenInNewTabControl(props: OpenInNewTabControlProps) {
  const { consultationId, roomId } = useParams()

  const href = consultationId ? `/visioconference?consultationId=${consultationId}` : roomId ? `/visioconference?roomId=${roomId}` : `/visioconference`

  return (
    <ControlBarItem>
      <Link to={href} target="_blank">
        <Fab color="primary" size="small">
          <OpenInNewIcon />
        </Fab>
      </Link>
    </ControlBarItem>
  )
}
